module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid9_800x682.5aa7bb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid9_800x682.jpg
// module id = Ndi4
// module chunks = 0